import * as actionTypes from '../actionTypes/Quiz'
import { updateObject } from '../utility'

export const initialState = {
    quizSets: null,
    quiz: {},
    question: {},
    quizId: '',
    quizSet: '',
}

const setQuizSets = (state, action) => {
    return updateObject(state, {
        quizSets: action.quizSets,
    })
}

const setQuizSet = (state, action) => {
    return updateObject(state, {
        quizSet: action.quizSet,
    })
}

const setQuizId = (state, action) => {
    return updateObject(state, {
        quizId: action.quizId,
    })
}

const setActiveQuestion = (state, action) => {
    return updateObject(state, {
        quiz: action.quiz,
        question: action.question,
    })
}

const resetState = () => initialState

const Quiz = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_QUIZ_SETS:
            return setQuizSets(state, action)
        case actionTypes.SET_QUIZ_SET:
            return setQuizSet(state, action)
        case actionTypes.SET_ACTIVE_QUESTION:
            return setActiveQuestion(state, action)
        case actionTypes.SET_QUIZ_ID:
            return setQuizId(state, action)
        case actionTypes.RESET_STATE:
            return resetState()
        default:
            return state
    }
}

export default Quiz
